var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoinMembership(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    fill: "#ffffff",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.4 823.2c-9.6 0-17.6-6.4-20-16L72 366.4H60c-26.4-0.8-47.2-22.4-47.2-48.8s21.6-48 48.8-48c26.4 0 48.8 21.6 48.8 48.8 0 6.4-1.6 13.6-4 20l-7.2 13.6 217.6 97.6L496 172l-12-8.8c-12.8-8.8-20.8-24-20.8-40 0-26.4 21.6-48.8 48.8-48.8s48.8 21.6 48.8 48.8c0 16-8 31.2-20.8 40l-12 8 160 278.4 236.8-98.4-6.4-14.4c-2.4-6.4-4-12.8-4-19.2 0-26.4 21.6-48.8 48.8-48.8 26.4 0 48.8 21.6 48.8 48.8 0 26.4-21.6 48.8-48.8 48.8h-13.6L847.2 808c-2.4 9.6-10.4 16-20 16H194.4z m16-40h601.6l88-377.6-212 88c-2.4 0.8-4.8 1.6-8 1.6-7.2 0-13.6-4-17.6-9.6L510.4 224 340.8 485.6c-4 5.6-10.4 9.6-16.8 9.6-3.2 0-5.6-0.8-8-1.6L123.2 407.2l87.2 376zM161.6 936c-13.6 0-24-10.4-24-24s10.4-24 24-24h699.2c13.6 0 24 10.4 24 24s-10.4 24-24 24H161.6z",
    fill: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinMembership);
export default __webpack_public_path__ + "static/media/join-membership.129cc1ad61609b686f572ed69534df3c.svg";
export { ForwardRef as ReactComponent };